<section class="pt-2">
  <div class="container-style">
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6 *ngIf="conceptInvoicingType === 1">
          {{ isFormView ? 'Registrar detalle del modelo de facturación ' : 'Detalle del modelo de facturación' }}
        </h6>
        <h6 *ngIf="conceptInvoicingType === 2">
          {{ isFormView ? 'Registrar detalle del modelo de compra ' : 'Detalle del modelo de compra' }}
        </h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end gap-2">
        <div class="d-flex gap-2">
          <app-custom-button [title]="'Importar Detalles'" [icon]="'pi pi-file-import'" [severity]="'primary'"
            [disabled]="disabledDetail" (onClick)="openInvoicingModelDetailImportModal()">
          </app-custom-button>
          <app-custom-modal #invoicingModelDetailImportModal [label]="'Importar Detalles'" [width]="'40rem'"
            [header]="'Importar Detalles'" [children]="componentInvoicingModelDetailImportModal"
            [inputs$]="inputsForInvoicingModelDetailImportModal$" (params)="reload($event.reload)" hidden>
          </app-custom-modal>
          <app-custom-button [title]="'Copiar Desde'" [icon]="'pi pi-copy'" [severity]="'warn'"
            [disabled]="disabledDetail" (onClick)="openCopyFromModal()">
          </app-custom-button>
          <app-custom-modal #copyInvoicingModelDetailImportFromModal [label]="'Copiar Desde'" [header]="'Copiar Desde'"
            [children]="componentCopyInvoicingModelDetailImportFromModal"
            [inputs$]="inputsForCopyInvoicingModelDetailFromModal$" hidden
            (selectedItems)="handleInvoicingModelDetailSelection($event)">
          </app-custom-modal>
          <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledDetail"
            [width]="'6.5rem'" (onClick)="createNewDetail()"></app-custom-button>
        </div>
      </div>
    </div>
    <div [hidden]="!isFormView" class="row mx-0">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-register-invoicing-model-detail [invoicingModelModel]="invoicingModelModel"
          [invoicingModelDetailContract]="invoicingModelDetailModel" [conceptInvoicingType]="conceptInvoicingType"
          (updateListDetail)="getInvoicingModelDetailsByInvoicingModel()"
          (isFormView)="getFormView($event)"></app-register-invoicing-model-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]=" !this.disabledDetail " [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getInvoicingModelDetailsByInvoicingModel()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>